<template>
  <div class="propiedades-page">
    <div class="page-header">
      <h2>Propiedades</h2>
      <button v-if="$store.getters['auth/puede']('arriendos.propiedades', 'escribir')" class="button-71 green-btn" @click="$router.push({ name: 'NuevaPropiedad' })">+ Nueva Propiedad</button>
    </div>
    <table class="propiedades-table">
      <thead>
        <tr>
          <th>Código</th>
          <th>Dirección</th>
          <th>Propietario</th>
          <th>Rol</th>
          <th>CBRS</th>
          <th>Notas</th>
          <th>m²</th>
          <th>Parking</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="prop in propiedades" :key="prop.pr_id">
          <td>{{ prop.pr_codigo }}</td>
          <td>{{ prop.pr_direccion }}</td>
          <td>{{ prop.pr_propietario || '-' }}</td>
          <td>{{ prop.pr_rol || '-' }}</td>
          <td>{{ prop.pr_cbrs || '-' }}</td>
          <td><span v-html="prop.pr_notas || '-'" /></td>
          <td>{{ prop.pr_m2 || '-' }}</td>
          <td>{{ prop.pr_num_parking || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiClient from '@/api/index';
export default {
  name: 'Propiedades',
  data() {
    return {
      propiedades: [],
    };
  },
  async mounted() {
    try {
      const res = await apiClient.get('/arriendos/propiedades');
      this.propiedades = Array.isArray(res.data) ? res.data : (res.data.propiedades || res.data.propiedad || []);
    } catch (e) {
      this.propiedades = [];
    }
  },
};
</script>

<style scoped>
.propiedades-page {
  padding: 2em;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1em;
}
.button-71.green-btn {
  background-color: #22c55e !important;
  color: #fff;
  border-radius: 12px !important;
  border: none;
  padding: 0.7em 1.5em;
  font-weight: 600;
  cursor: pointer;
}
.propiedades-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.98em;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.propiedades-table th, .propiedades-table td {
  padding: 0.7em 1em;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}
.propiedades-table th {
  background: #f0f9ff;
  font-weight: 600;
}
.propiedades-table tbody tr:nth-child(even) {
  background: #f6fafd;
}
.propiedades-table tbody tr:nth-child(odd) {
  background: #fff;
}
</style>
